<template>
  <PageSecondary>
    <template #title>Просто Прости и Прощай</template>

    <p>
      В статье исследуем значение слова "прощай". Я&nbsp;начну издалека, с приставок и корней.
    </p>
    <h4>Про</h4>
    <p>
      Приставка <i>про-</i> и предлог <i>про</i> и сейчас широко используются в русском языке. Первоначальное их значение,
      существовавшее, видимо, еще в праиндоевропейскую эпоху, – ‘движение вперед’. Есть предположение, что <i>pro</i> восходит
      к еще более древнему корню <i>pr</i>, от которого в современном русском языке происходят также слова <i>перед</i>, <i>переть</i> (в
      значении ‘двигаться вперед’) и, возможно, <i>прямо</i> (близкие по смыслу выражения ’идти прямо’, ’идти вперед’).
    </p>
    <h4>Ста</h4>
    <p>
      Праславянский корень <i>sta</i> (из индоевропейского <i>st</i>) ученые объясняли по-разному (например, соотнося его со словами
      балтийских языков со значением ‘щедрый, обильный’ и др.). В настоящее время существует довольно убедительная
      гипотеза, что этимологический корень <i>sta</i> в слове простъ – тот же, что в современных русских словах стать, стоять,
      в английском слове <i>stand</i>, немецком <i>stehen</i> и др.
    </p>

    <h4>Прост</h4>
    <p>
      Если свести воедино все сказанное, можно предположить, что корень <i>prost</i> когда-то имел значение <i>прямо стоящий</i>.
      Одним из доказательств этой гипотезы служит наличие в польском языке слова <i>prosty</i> со значением <i>простой</i>,
      <i>прямой</i>.
    </p>

    <ImgBlock asset="handdrawn/bye-sorry-ok.jpg"/>

    <h4>Простить</h4>
    <p>
      А теперь про <i>Прости́ть</i>, которое значит сейчас ’забыть вину, обиду’.
    </p>
    <p>
      Глагол образован от древнерусского <i>простъ</i> (к которому восходит и современное простой). Прость значило: прямой,
      несогнутый, обыкновенный, просто устроенный, свободный, неизысканный, откровенный, простодушный, скромный
    </p>
    <p>
      <i>Простить</i> поэтому имело значение «выпрямить», «разрешить виноватому, согнувшемуся в раболепном поклоне,
      выпрямиться».
    </p>
    <p>
      Другие слова<br>
      др.-русск. <i>простити</i>, значило «исцелить»<br>
      чеш. <i>prostiti</i> «освободить»
    </p>
    <h4>Прощай</h4>
    <p>
      А <i>Прощай</i> при расставании - просьба прощающегося простить его, пока можно сделать это в контакте, лично смотря на
      человека.
    </p>

  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";
import ImgBlock from "@/components/blocks/ImgBlock";

export default {
  name: "Sorry",
  components: {ImgBlock, PageSecondary}
}
</script>

<style scoped>

</style>